import type { Guardiao } from './guardioesService';

/** A partir de quantos nomes o mural rola (com menos, fica parado e centralizado — repetir os
 * nomes pra rolar sem emenda fazia a mesma pessoa aparecer duas vezes). */
const MINIMO_PARA_ROLAR = 8;

/** Mural dos Guardiões: só os nomes (sem nota, sem ranking), mais recentes primeiro. Com bastante
 * gente, duas faixas rolando em sentidos opostos (pausa ao passar o mouse; parado pra quem pede
 * menos movimento no sistema). */
export function MuralGuardioes({ guardioes }: { guardioes: Guardiao[] }) {
  const ordenados = [...guardioes].sort((a, b) => (b.aprovadoEm?.toMillis?.() ?? 0) - (a.aprovadoEm?.toMillis?.() ?? 0));

  const chip = (g: Guardiao, chave: string) => (
    <span
      key={chave}
      className="inline-flex shrink-0 items-center gap-2 rounded-full border border-primary-100 bg-primary-50/60 px-3 py-1.5 text-sm font-medium text-raro-gray-800"
    >
      <span className="grid h-5 w-5 place-items-center rounded-full bg-primary-600 text-[10px] text-white" aria-hidden="true">
        🛡
      </span>
      {g.nome}
    </span>
  );

  if (ordenados.length < MINIMO_PARA_ROLAR) {
    return (
      <div className="flex flex-wrap justify-center gap-3 rounded-2xl border border-primary-100 bg-white px-4 py-5 shadow-sm">
        {ordenados.map((g) => chip(g, g.email))}
      </div>
    );
  }

  const metade = Math.ceil(ordenados.length / 2);
  const faixas = [ordenados.slice(0, metade), ordenados.slice(metade)];

  return (
    <div className="overflow-hidden rounded-2xl border border-primary-100 bg-white py-4 shadow-sm">
      <style>{`
        @keyframes muralGuardioes { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .mural-guardioes { animation: muralGuardioes 45s linear infinite; }
        .mural-guardioes:hover { animation-play-state: paused; }
        @media (prefers-reduced-motion: reduce) { .mural-guardioes { animation: none; } .mural-guardioes > [data-copia] { display: none; } }
      `}</style>
      {faixas.map((faixa, i) => (
        <div
          key={i}
          className={`mural-guardioes flex w-max gap-3 px-3 ${i > 0 ? 'mt-3' : ''}`}
          style={i > 0 ? { animationDirection: 'reverse', animationDuration: '55s' } : undefined}
        >
          {faixa.map((g) => chip(g, g.email))}
          {/* Cópia só pra rolagem não ter emenda (a animação anda metade da largura); escondida pros leitores de tela. */}
          <span data-copia aria-hidden="true" className="flex gap-3">
            {faixa.map((g) => chip(g, `${g.email}-copia`))}
          </span>
        </div>
      ))}
    </div>
  );
}
